(()=>{
  if(window.__WN_STARTER_BUNDLE_FIXES_V4__)return;
  window.__WN_STARTER_BUNDLE_FIXES_V4__=1;

  const R=window.Shopify?.routes?.root||'/';
  const STARTER=57337524093252;
  const NAMI_PRODUCT=15580935422276;
  let guardBusy=false;
  let latestCart=null;

  const req=async(u,b)=>{const r=await fetch(R+u,{method:b?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:b?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},body:b?JSON.stringify(b):undefined});const j=await r.json();if(!r.ok)throw Error(j.description||j.message||'Cart update failed');return j};

  const getStarterLines=c=>(c?.items||[]).filter(i=>Number(i.variant_id)===STARTER);
  const namiQty=c=>(c?.items||[]).filter(i=>Number(i.product_id)===NAMI_PRODUCT).reduce((n,i)=>n+Number(i.quantity||0),0);
  const invalid=c=>{const st=getStarterLines(c),n=namiQty(c),qty=st.reduce((x,i)=>x+Number(i.quantity||0),0);return st.length>0&&(n<1||st.length>1||qty>n)};

  async function refresh(source){
    if(window.WNCart?.refresh)return window.WNCart.refresh({emit:true,source,openDrawer:false});
    latestCart=await req('cart.js');
    document.dispatchEvent(new CustomEvent('wn:cart:updated',{detail:{cart:latestCart,source,openDrawer:false}}));
    return latestCart;
  }

  async function guard(seed=null){
    if(guardBusy)return seed||latestCart;
    guardBusy=true;
    try{
      let c=seed&&Array.isArray(seed.items)?seed:await req('cart.js');
      latestCart=c;
      const st=getStarterLines(c),n=namiQty(c);
      if(!st.length)return c;
      const updates={};
      if(n<1){st.forEach(i=>updates[i.key]=0)}
      else{
        if(st[0]&&Number(st[0].quantity)!==Math.min(n,1))updates[st[0].key]=Math.min(n,1);
        st.slice(1).forEach(i=>updates[i.key]=0);
      }
      if(Object.keys(updates).length){
        c=await req('cart/update.js',{updates});
        latestCart=c;
        await refresh('starter-bundle-dependency-guard');
      }
      return c;
    }catch(err){console.warn('Nami starter bundle guard',err);return latestCart}finally{guardBusy=false}
  }

  function scheduleGuard(seed=null){
    if(seed?.items)latestCart=seed;
    requestAnimationFrame(()=>guard(latestCart).catch(()=>{}));
  }

  document.addEventListener('wn:cart:updated',e=>scheduleGuard(e.detail?.cart||null));
  document.addEventListener('shopify:section:load',()=>scheduleGuard());
  window.addEventListener('pageshow',()=>scheduleGuard());

  document.addEventListener('click',e=>{
    const link=e.target?.closest?.('[data-wn-starter-bundle-item] a[href], .wn-cart-item--care-starter-actual a[href]');
    if(!link||link.matches('[data-cart-remove]'))return;
    e.preventDefault();
    e.stopImmediatePropagation();
  },true);

  document.addEventListener('click',e=>{
    const checkout=e.target?.closest?.('[data-cart-checkout-direct],[data-cart-checkout]');
    if(!checkout||!latestCart||!invalid(latestCart))return;
    e.preventDefault();
    e.stopImmediatePropagation();
    guard(latestCart).then(()=>refresh('starter-bundle-checkout-guard')).catch(()=>{});
  },true);
  document.addEventListener('submit',e=>{
    const checkout=e.submitter?.closest?.('[data-cart-checkout]');
    if(!checkout||!latestCart||!invalid(latestCart))return;
    e.preventDefault();
    e.stopImmediatePropagation();
    guard(latestCart).then(()=>refresh('starter-bundle-checkout-guard')).catch(()=>{});
  },true);

  const start=()=>scheduleGuard();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
